import styled from "styled-components";

export const JackpotBetWinHighlightContenDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    &.fade-in {
        opacity: 1;
        transform: translateY(0);
        animation: shake 0.3s;
    }

    &.fade-out {
        opacity: 0;
        transform: translateY(20px);
    }

    @keyframes shake {
        10% {
        transform: translate3d(0, 10px, 0);
        }
        30% {
        transform: translate3d(0, -5px, 0);
        }
        60% {
        transform: translate3d(0, 2px, 0);
        }
        90% {
        transform: translate3d(0, -2px, 0);
        }
    }
`